<template>
  <span
    class="text-sm font-medium mr-2 px-2 py-0.5 rounded"
    :class="{ 'uppercase' : uppercase,
              'bg-slate-100 text-slate-800' : color=='default',
              'bg-red-100 text-red-800' : color=='red',
              'bg-green-100 text-green-800' : color=='green',
              'bg-amber-100 text-amber-800' : color=='amber',
    }">
    <slot></slot>
  </span>
</template>
 <script>
 export default {
   props: {
     color: {
       type: String,
       default: 'default'
     },
     uppercase: {
       type: Boolean,
       default: true
     }
   },
 };
 </script>